import { BaseHTMLAttributes, FC } from 'react';

import { BubbleText } from '../common/BubbleText';
import { Text } from '../theme/Text';
import { Appointment } from './types';

export const AppointmentDetailBubbles: FC<
  { appointment: Appointment } & BaseHTMLAttributes<HTMLDivElement>
> = ({ appointment, ...rest }) => {
  return (
    <div className="flex mt-2 gap-2" {...rest}>
      <BubbleText>
        <Text variant="body-6">{appointment.duration} mins</Text>
      </BubbleText>
      {appointment.caregiverOnly && (
        <BubbleText style={{ backgroundColor: 'var(--purple-2)' }}>
          <Text variant="body-6">Caregiver-only</Text>
        </BubbleText>
      )}
    </div>
  );
};
